import { useState } from 'react'

import OCRService from '../lib/OCRService'

import axiosInstance from '../services/config/AxiosIntance'

const useParseCV = () => {
  const [loading, setLoading] = useState(false)

  const parseCV = async (uploadedCv, applicantId) => {
    setLoading(true)

    try {
      if (Array.isArray(uploadedCv) && uploadedCv?.length === 0)
        throw new Error('Applicant has no uploaded CV')

      // 1. Get all images
      const cvImages = Array.from(
        { length: uploadedCv?.pages },
        (_, i) =>
          `http://res.cloudinary.com/hopla-online/image/upload/w_800/q_60/pg_${
            i + 1
          }//v${uploadedCv?.version}/${uploadedCv?.public_id}.jpg`
      )

      // 2. Get all text from images
      const ocrService = new OCRService()
      const mergedText = await ocrService.convertImagesToText(cvImages)

      // 3. Run AI prompt and get parsed data
      const result = await axiosInstance.post('/claude-ai/cv/recruiter', {
        ocrText: mergedText,
      })

      const response = result?.data?.data

      const fullPayload = {
        ...response.profile,
        character_reference: JSON.stringify(
          response.profile.character_reference
        ),
        meta: JSON.stringify({
          ...response.profile.meta,
          fullSkills: response.skills,
        }),
        professional_headline: JSON.stringify(
          response.profile.professional_headline
        ),
        is_parsed: 1,
      }

      // 4. Save to database
      return await axiosInstance.put(
        `/applicant/${applicantId}/update`,
        fullPayload
      )
    } catch (err) {
      const errorMessage =
        err?.message || 'Failed to parse uploaded CV. Please try again.'
      throw new Error(errorMessage)
    } finally {
      setLoading(false)
    }
  }

  return { loading, parseCV }
}

export default useParseCV
